import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useAuth } from '../auth/AuthProvider';
import { functions } from '../firebase';
import type { UnitMapUnit } from '../lib/unitMap';

export interface UnitMapResponse {
  scope: { kind: 'district' | 'tenant'; districtId: string | null };
  districts: Array<{ id: string; name: string }>;
  units: UnitMapUnit[];
}

export function useUnitMap() {
  const { profile, tenantIds } = useAuth();
  const tenantId = profile ? (tenantIds[0] ?? null) : null;
  const [data, setData] = useState<UnitMapResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setData(null);
    setError('');
    setLoading(true);
    if (!tenantId) {
      setLoading(false);
      return () => { cancelled = true; };
    }
    const call = httpsCallable<Record<string, never>, UnitMapResponse>(functions, 'listVisibleUnitMapV2');
    void call({}).then((result) => {
      if (!cancelled) setData(result.data);
    }).catch((cause) => {
      if (!cancelled) setError(cause instanceof Error ? cause.message : 'Unable to load Unit Map data.');
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [tenantId]);

  return { data, loading, error };
}
